import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { LivingTenantOptionFilter, RentConditionsFilter } from '../../../../models/Filter';
import { RentConditionButtonFilterView } from '../../desktop/rent_conditions/RentConditionButtonFilterView';

interface IRentConditionFilter {
    conditionFilter: RentConditionsFilter;
    tenantOptionFilter: LivingTenantOptionFilter;
    handleChange: (filter: RentConditionsFilter | LivingTenantOptionFilter) => void;
    isHouse?: boolean;
    classNameGroup?: string;
}

export const MobileRentConditionsFilterButtonView: React.FC<IRentConditionFilter> = ({
    conditionFilter,
    tenantOptionFilter,
    handleChange,
    isHouse,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Условия'>
            <RentConditionButtonFilterView
                conditionFilter={conditionFilter}
                tenantOptionFilter={tenantOptionFilter}
                handleChange={handleChange}
                isHouse={isHouse}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
